import type {ReactNode} from "react";

export default function DungeonEditorWorkspace({sidebar, children}: {
    sidebar: ReactNode;
    children: ReactNode;
}) {
    return <section
        className="grid size-full min-h-0 grid-cols-[15rem_minmax(0,1fr)] overflow-hidden rounded-lg border bg-card">
        <aside className="flex min-h-0 flex-col border-r">
            <div className="min-h-0 flex-1 space-y-3 overflow-auto p-3">{sidebar}</div>
        </aside>
        <div className="min-h-0">{children}</div>
    </section>;
}
